@if (cart()?.id; as cartId) {
  <div class="employee-basket-cart-sign">
    <div class="employee-basket-cart-sign__title-row">
      <h2 class="employee-basket-cart-sign__title">
        {{ 'employee.benefit-addendum-sign.sign-button' | translate }}
      </h2>
      <button class="employee-basket-cart-sign__close" type="button" (click)="onCancelSign()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider class="fo-employee-benefit-card-divider"></mat-divider>
    <div
      class="employee-basket-cart-sign__signing"
      [class.employee-basket-cart-sign__signing--blocked]="isInsufficientBudget()"
    >
      <div class="employee-basket-cart-sign__signing-content">
        @if (cartAddendum()) {
          <button
            class="employee-basket-cart-sign__download-link"
            matButton
            type="button"
            (click)="onDownloadCartAddendum()"
          >
            {{ 'employee-benefits.download-amendment' | translate | uppercase }}
          </button>
        }
        @if (showQuillSignatureType$ | async) {
          <app-benefit-addendum-sign
            [cartId]="cartId"
            [documents]="cart()?.documents ?? []"
            [quillDocumentId]="cart()?.quillDocumentId ?? null"
            (benefitAddendumSignStatusChanged)="onCartAddendumSignStatusChanged($event)"
          />
        }
        @if (showUploadSignBlock && (showManualSignatureType$ | async)) {
          <app-employee-benefit-agreement-sign-digital
            [hasExistingAddendum]="hasValidCartAddendum()"
            [isQuillSignPossible]="showQuillSignatureType()"
            (cancelSignAgreement)="onCancelSign()"
            (downloadBenefitAddendumTemplate)="onDownloadCartAddendumTemplate()"
            (send)="onUploadCartAddendum($event)"
          />
        }
      </div>
      @if (isInsufficientBudget()) {
        <div class="employee-basket-cart-sign__order-warning-wrapper">
          <div class="employee-basket-cart-sign__order-warning">
            <mat-icon
              class="employee-basket-cart-sign__order-warning-icon"
              svgIcon="fo-warn"
            ></mat-icon>
            <span>{{ 'employee.basket.insufficient-budget-warning' | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
